import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { APP_CONFIG } from '../core';


/**
* This service handles base help modal.
*/
export class BaseHelpService {

	protected http = inject(HttpClient);
	protected config = inject(APP_CONFIG);
	protected sanitizer = inject(DomSanitizer);

	private fileNameList: any;
	private _isLoaded = false;
	private _lang: string | null = null;

	/**
	* Check if help file name list is loaded.
	*/
	get isLoaded(): boolean {
		return this._isLoaded;
	}

	/**
	* Load help file name list.
	*/
	loadFileNames(lang: string): Observable<any> {
		return this.http.get(this.config.helpSite.fileNames).pipe(tap(list => {
			this._lang = lang;
			this.fileNameList = list;
			this._isLoaded = true;
		}));
	}

	/**
	* Get safe url of help.
	*/
	get safeUrl(): SafeUrl | null {
		const url = this.helpUrl;
		return url ? this.sanitizer.bypassSecurityTrustResourceUrl(url) : null;
	}

	private get helpUrl(): string | null {
		const fileName = this.fileNameList ? this.fileNameList[this.fileKey] : null;
		return fileName ? `${this.config.helpSite.baseUrl}/${this._lang}/${fileName}.html` : null;
	}

	get fileKey(): string {
		return ``;
	}

}
